import { useState } from "react";
import { APP_KEY_IDS } from "../../../constants/constants";
import BaseMobileAppContainer from "../base-mobile-app-container/BaseMobileAppContainer";
import Styles from "./Settings.module.scss";
import MobileOptionsList from "../mobile-options-list/MobileOptionsList";
import { useDispatch } from "react-redux";
import { openWindow } from "../../../actions";
import Appearance from "../../settings/appearance/Appearance";
import Display from "./display/Display";


//Icons

import ConnectionsIcon from "../../../icons/settings/mobile_settings/connections.png"
import ConnectedDevicedIcon from "../../../icons/settings/mobile_settings/connected_devices.png"
import ModesIcon from "../../../icons/settings/mobile_settings/modes_and_routines.png"
import SoundIcon from "../../../icons/settings/mobile_settings/sounds.png"
import NotificationsIcon from "../../../icons/settings/mobile_settings/notifications.png"
import DisplayIcon from "../../../icons/settings/mobile_settings/display.png"
import WallpapersIcon from "../../../icons/settings/mobile_settings/wallpapers.png"
import ThemesIcon from "../../../icons/settings/mobile_settings/themes.png"
import HomeIcon from "../../../icons/settings/mobile_settings/home.png"
import LockIcon from "../../../icons/settings/mobile_settings/lock.png"
import SecurityIcon from "../../../icons/settings/mobile_settings/security.png"
import LocationIcon from "../../../icons/settings/mobile_settings/locations.png"
import SafetyIcon from "../../../icons/settings/mobile_settings/safety.png"
import AccountsIcon from "../../../icons/settings/mobile_settings/accounts.png"
import GoogleIcon from "../../../icons/settings/mobile_settings/google.png"
import AdvancedIcon from "../../../icons/settings/mobile_settings/advanced.png"
import DigitalIcon from "../../../icons/settings/mobile_settings/digital_wellbeing.png"
import BatteryIcon from "../../../icons/settings/mobile_settings/battery.png"
import AppsIcon from "../../../icons/settings/mobile_settings/themes.png"
import GeneralIcon from "../../../icons/settings/mobile_settings/general.png"
import AccessibilityIcon from "../../../icons/settings/mobile_settings/accessibility.png"
import SoftwareIcon from "../../../icons/settings/mobile_settings/software.png"
import UserIcon from "../../../icons/settings/mobile_settings/user_manual.png"
import RemoteIcon from "../../../icons/settings/mobile_settings/remote_support.png"
import AboutIcon from "../../../icons/settings/mobile_settings/about_phone.png"
import { SPECIAL_ROUTE_HARACTER, getCurrentOption, gotoPreviousOption } from "../../../global/functions/functrions";
import Themes from "./themes/Themes";
import PlaceHolder from "./placeholder/PlaceHolder";
import Wallpapers from "./wallpapers/Wallpapers";
import AboutPhone from "./about-phone/AboutPhone";


interface SettingsProps{
    wallpapers:any;
}

const Settings = ({wallpapers}:SettingsProps) => {

    const menuOptions = [
        {
            label: "",
            options: [
                {
                    id: "0",
                    label: "Connections",
                    subLabel: "Wifi - Bluetooth - Sim manager",
                    icon: ConnectionsIcon
                },
                {
                    id: "1",
                    label: "Connected Device",
                    subLabel: "Quick Share - Samsung Dex - Android auto",
                    icon: ConnectedDevicedIcon
                },
            ]
        },
        {
            label: "",
            options: [
                {
                    id: "2",
                    label: "Modes and Routines",
                    subLabel: "Modes - Routines",
                    icon: ModesIcon
                },
                {
                    id: "3",
                    label: "Sound and Vibration",
                    subLabel: "Sound - Ringhtone",
                    icon: SoundIcon
                },
                {
                    id: "4",
                    label: "Notifications",
                    subLabel: "Status Bar - Do not disturb",
                    icon: NotificationsIcon
                },
            ]
        },
        {
            label: "",
            options: [
                {
                    id: "5",
                    label: "Display",
                    subLabel: "Brightness - Eye Comfort Sheild - NavigationBar",
                    icon: DisplayIcon
                },
                {
                    id: "6",
                    label: "Wallpaper and Styles",
                    subLabel: "Wallpapers - Color palette",
                    icon: WallpapersIcon,
                    childOptions:[
                        {
                            id:"6_1",
                            leftComponent:"Change Wallpaper"
                        }
                    ]
                },
                {
                    id: "7",
                    label: "Themes",
                    subLabel: "Themes - Wallpapers - Icons",
                    icon: ThemesIcon
                },
                {
                    id: "8",
                    label: "Home Screen",
                    subLabel: "Layout - App Icons badge",
                    icon: HomeIcon
                },
                {
                    id: "9",
                    label: "Lock Screen",
                    subLabel: "Screen lock type - Always on display",
                    icon: LockIcon
                },
            ]
        },
        {
            label: "",
            options: [
                {
                    id: "11",
                    label: "Security & Privacy",
                    subLabel: "Biometrics - Permission Manager",
                    icon: SecurityIcon
                },
                {
                    id: "12",
                    label: "Location",
                    subLabel: "Location requests",
                    icon: LocationIcon
                },
                {
                    id: "13",
                    label: "Safety & Emergency",
                    subLabel: "Medical info - Wireless emergency alerts",
                    icon: SafetyIcon
                },
            ]
        },
        {
            label: "",
            options: [
                {
                    id: "14",
                    label: "Accounts & Backup",
                    subLabel: "Manage accounts - Smart switch",
                    icon: AccountsIcon
                },
                {
                    id: "15",
                    label: "Google",
                    subLabel: "Google services",
                    icon: GoogleIcon
                },
            ]
        },
        {
            label: "",
            options: [
                {
                    id: "16",
                    label: "Advanced features",
                    subLabel: "Labs - SIde key",
                    icon: AdvancedIcon
                },
            ]
        },
        {
            label: "",
            options: [
                {
                    id: "17",
                    label: "Digital Wellbeing & Parental COntrols",
                    subLabel: "Screen time - App timers",
                    icon: DigitalIcon
                },
                {
                    id: "18",
                    label: "Battery & Device care",
                    subLabel: "Storage - Memory - Device protection",
                    icon: BatteryIcon
                },
                {
                    id: "19",
                    label: "Apps",
                    subLabel: "Default apps - App Settings",
                    icon: AppsIcon
                },
            ]
        }, ,
        {
            label: "",
            options: [
                {
                    id: "20",
                    label: "General Management",
                    subLabel: "Language and Keybord - Date and time",
                    icon: GeneralIcon
                },
                {
                    id: "21",
                    label: "Accessibility",
                    subLabel: "Talkback - Mono AUdio - Assistant menu",
                    icon: AccessibilityIcon
                },
            ]
        },
        {
            label: "",
            options: [
                {
                    id: "22",
                    label: "Software Update",
                    subLabel: "Download and Install",
                    icon: SoftwareIcon
                },
                {
                    id: "23",
                    label: "User Manual",
                    subLabel: "Learn more",
                    icon: UserIcon
                },
                {
                    id: "24",
                    label: "Remote Support",
                    subLabel: "Remote Support",
                    icon: RemoteIcon
                }, ,
                {
                    id: "25",
                    label: "About Phone",
                    subLabel: "Status - Legal information - Phone name",
                    icon: AboutIcon
                },
            ]
        },

    ]

    const dispatch = useDispatch()

    const [activeId, setActiveId] = useState("")

    const [subOptions, setSubOptions] = useState([]);

    const [activeOptionTitle, setActiveOptionTitle] = useState("Settings");

    const handleBackClick = () => {
        if(activeId.includes("_")){
            setActiveId(gotoPreviousOption(activeId,"_"))
        }
        else{
            setActiveId("")
            setActiveOptionTitle("Settings")
        }
    }

    const handleOptionClick = (data:any) => {
        setActiveId(data)
    }

    const handleSubOptionSelection= (selectedBlock:any) => {
        setSubOptions(selectedBlock.childOptions ? selectedBlock.childOptions : [])
    }

    const getMainScreen = () => {
        switch (getCurrentOption(activeId,"subOtion","_")) {
            case "5": return <Display />
            case "6": return <Wallpapers wallpapers={wallpapers} subOptions={subOptions} activeOption={activeId} onClickOption={handleOptionClick}/>
            case "7": return <Themes />
            case "25": return <AboutPhone />
            default: return <PlaceHolder/>
        }
    }

    return (
        <BaseMobileAppContainer
            title={activeOptionTitle}
            appId={APP_KEY_IDS.MOBILE_SETTINGS}
            MainMenuOptions={
                activeId ? getMainScreen()
                    : <div className={Styles.options_container}>
                        <div className={Styles.help_container}>
                            <div className={Styles.text} onClick={() => { dispatch(openWindow(APP_KEY_IDS.HELP)) }}>
                                Help ?
                            </div>
                        </div>
                        {
                            menuOptions.map((optionsBlock: any, index: number) => {
                                return (
                                    <MobileOptionsList key={index} activeValue={activeId} handleOptionClick={setActiveId} menuContent={optionsBlock.options} setTitle={setActiveOptionTitle} onSuccessfulSubmission={handleSubOptionSelection}/>
                                )
                            })
                        }
                        <div className={Styles.space} />
                    </div>
            }
            MainScreen={null}
            isMainScreenActive={!!activeId}
            isForcedCompactView={!!activeId}
            handleBackClick={handleBackClick}
        />
    )
}

export default Settings